export default __webpack_public_path__ + "static/media/README.607bf7df.md";